import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "app-send-scam-warning",
	templateUrl: "./send-scam-warning.component.html",
	styleUrls: ["./send-scam-warning.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SendScamWarningComponent {
	@Input() description: string;

	constructor(
		private segmentService: SegmentService,
		private rudderstackService: RudderstackService
	) {}

	getReadMoreUrl(): string {
		const isoCode = TranslationService.getLanguageIsoCode();
		return (
			config.helpcenterUrl +
			"hc/" +
			(isoCode === "en" ? "en-us" : isoCode) +
			"/articles/360001414160-How-to-spot-online-scams"
		);
	}

	clickReadMoreUrl(): void {
		this.segmentService.track({
			name: 'Send Scam Warning - "Read more" button Clicked'
		});
		this.rudderstackService.track({
			name: 'Send Scam Warning - "Read more" button Clicked'
		});
	}
}
